import axios from "axios";

export type ConfigApi<TConfig extends { id: string }> = {
    list: () => Promise<TConfig[]>;
    create: (name: string) => Promise<TConfig>;
    edit: (config: TConfig["id"], name: string) => Promise<void>;
    remove: (config: TConfig["id"]) => Promise<void>;
};

export function makeConfigApi<TConfig extends { id: string }>(segment: string): ConfigApi<TConfig> {
    const url = `/api/v0/project-configurations/${segment}`;
    return {
        list: async () => {
            const { data: configs } = await axios.get<TConfig[]>(url);
            return configs;
        },
        create: async (name) => {
            const { data: config } = await axios.post<TConfig>(url, { name });
            return config;
        },
        edit: async (config, name) => {
            await axios.put(`${url}/${config}`, { name });
        },
        remove: async (config) => {
            await axios.delete(`${url}/${config}`);
        },
    };
}
